<script setup lang="ts">
import { computed, ref } from "vue"
import { useShopAppConfig } from "@/shop/composables"

const { appConfig } = useShopAppConfig()

const currentParagraph = ref(0)
const totalParagraphs = 3
const isConfirmed = ref(false)

function goToNextParagraph() {
    if (currentParagraph.value < totalParagraphs - 1) {
        currentParagraph.value++
    }
}

const isLastParagraph = computed(() => currentParagraph.value === totalParagraphs - 1)
const emit = defineEmits(["accepted"])

function confirmEtiquette() {
    emit("accepted")
}
</script>

<template>
    <div>
        <!-- Paragraph 1 -->
        <template v-if="currentParagraph === 0">
            <p>Moin {{ appConfig.user.firstName }}!</p>
            <p>
                Wir bemühen uns täglich darum, unseren Kunden und Patienten nicht nur ein breites Angebot unserer
                lagernden Produkte, sondern auch ein großes Serviceangebot zu bieten. Dazu haben wir unser
                Cannabisblüten-Sortiment auf vorgegebene Gebindegrößen zu 5g oder 10g umgestellt – unsere CANN24
                readymade Doypacks. Gib bei deiner Sorte einfach deine gewünschte Gesamtmenge an und dir wird angezeigt
                in welcher Kombination aus Gebinden du deine Bestellung voraussichtlich erhalten wirst.
            </p>
        </template>

        <!-- Paragraph 2 -->
        <template v-if="currentParagraph === 1">
            <p><b>Öffnungszeiten und Lieferung:</b></p>
            <p>
                Die Apotheke ist außer an Feiertagen von
                <b>Montag bis Freitag durchgehend geöffnet von 8:00-18:30 Uhr</b>. Bei Bestellung von CANN24 readymade,
                CANN24 milled oder CANN24 smalls Produkten entfällt die Wartezeit der Herstellung. Wenn wir deinen Rezept- und
                Zahlungseingang bis spätestens 15:00 Uhr feststellen konnten, versenden wir noch am selben Tag. Eine
                Abholung vor Ort ist ohne Termin <b>bis 17:30 Uhr</b> möglich.
                <b
                    >Solltest du erst danach kommen können, ruf uns bitte vorher an und wir besprechen mit dir, ob es
                    möglich ist.</b
                >
            </p>
        </template>

        <!-- Paragraph 3 -->
        <template v-if="currentParagraph === 2">
            <p><b>Beleidigungen, Drohungen, Sachbeschädigung:</b></p>
            <p>
                Manche Patienten haben aufgrund ihrer Erkrankung einen hohen Leidensdruck. Das ist uns bewusst und Teil
                unserer täglichen Arbeit damit umgehen zu können. Gewissen Unmutsäußerungen können wir daher
                professionell begegnen und versuchen immer zu helfen. Eine Grenze wird jedoch überschritten bei
                persönlichen Beleidigungen und der Androhung oder womöglich sogar der Ausübung von Gewalt oder
                Sachbeschädigung.
                <b
                    >In aller Deutlichkeit: Für rassistische, frauenfeindliche oder andere menschenverachtende
                    Beleidigungen, Androhung oder Ausübung von Gewalt und Sachbeschädigung gilt bei uns eine
                    Null-Toleranz-Politik. Derartiges Verhalten führt zum sofortigen Ausschluss der weiteren Versorgung,
                    Hausverbot und wird direkt zur Anzeige gebracht.</b
                >
            </p>
        </template>

        <!-- Navigation Buttons -->
        <div v-if="!isLastParagraph" class="mt-5">
            <button type="button" class="btn btn-primary-filled" @click="goToNextParagraph">
                Gelesen ({{ currentParagraph + 1 }}/{{ totalParagraphs }})
            </button>
        </div>

        <!-- Confirmation Section -->
        <div v-else>
            <div class="form-check mt-5 mb-3">
                <input id="confirmCheckbox" v-model="isConfirmed" type="checkbox" class="mr-1" />
                <label for="confirmCheckbox" class="form-check-label">Ich habe alles gelesen und verstanden</label>
            </div>
            <button class="btn btn-primary-filled" :disabled="!isConfirmed" @click="confirmEtiquette">Schließen</button>
        </div>
    </div>
</template>
